import { useIntl } from 'react-intl';

import { useFeatureFlags } from '@context/featureFlags/FeatureFlagsProvider';

import messages from '../../messages';
import { RichContentTabVariant } from '../model';

export const useRichContentTabTitle = () => {
  const { formatMessage } = useIntl();
  const { richContentTabVariant } = useFeatureFlags();

  return formatMessage(
    richContentTabVariant === RichContentTabVariant.Default
      ? messages.fixedHeaderRichContent
      : messages.fixedHeaderRichContentAbTest
  );
};
